import script from "./pageLesson.vue?vue&type=script&setup=true&lang=js"
export * from "./pageLesson.vue?vue&type=script&setup=true&lang=js"

import "./pageLesson.vue?vue&type=style&index=0&id=6ea48dbc&lang=scss"

const __exports__ = script;

export default __exports__